import React from "react";
import StudentPerformanceChart from "../components/work-reports/student-performance-chart/StudentPerformanceChart";
import StudentPerformanceTable from "../components/work-reports/student-performance-table/StudentPerformanceTable";
import TimeLine from "../components/work-reports/time-line/TimeLine";
import AuthContext from "../contexts/AuthContext";
import './DashboardRoute.scss';


export default class DashboardRoute extends React.PureComponent<{}, { username: string }> {

    static contextType = AuthContext;
    /**
     *
     */
    constructor(props: any) {
        super(props);
        this.state = { username: '' };
    }
    componentDidUpdate() {
        this.setState({ username: this.context.userInformation.personal.firstName + " " + this.context.userInformation.personal.lastName });
    }
    componentDidMount = () => {
        this.setState({ username: this.context.userInformation.personal.firstName + " " + this.context.userInformation.personal.lastName });
    }
    render(): React.ReactNode {
        return (
            <>
                <div className="content-menu dashboard-route-area px-4">
                    <div className="dropdown-list">
                        <div className="col-12">
                            <TimeLine username={this.state.username} />
                        </div>
                        <div className="col-12">
                            <div className="tk-card padding-bottom-remove">
                                <StudentPerformanceChart />
                            </div>
                        </div>
                        <div className="col-12">
                            <div className="tk-card">
                                <StudentPerformanceTable />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}